var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1140,
    height: 900,
    viewBox: "0 0 1140 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_44_793)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 427.452,
    cy: 545.106,
    r: 226.613,
    fill: "#C0F0FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492.686,
    cy: 469.163,
    r: 226.613,
    fill: "#93AAFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 577.392,
    cy: 428.27,
    r: 226.613,
    fill: "#FEBDFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M391.428 425.593C398.243 363.767 425.262 347.459 502.422 352.57C509.481 356.221 522.333 369.901 517.27 395.41C510.941 427.297 446.438 392.733 446.438 407.824C446.438 422.915 461.286 465.268 446.438 501.779C431.59 538.291 431.103 600.603 414.552 651.475C398 702.348 371.468 705.512 349.805 712.084C332.475 717.342 311.428 714.275 303.071 712.084C350.535 690.421 337.391 683.362 363.193 663.889C388.994 644.417 384.613 487.418 391.428 425.593Z",
    fill: "#FA00FF",
    fillOpacity: 0.63
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 713.213,
    cy: 415.613,
    r: 226.613,
    fill: "#FEDEFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_44_793",
    x: 0.839355,
    y: -11,
    width: 1138.99,
    height: 982.719,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_44_793"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/BG.86775ceea99dbf1d10cce83e5103f716.svg";
export { ForwardRef as ReactComponent };